import { createContext, useContext } from "react";

type NotificationContextType = {
  callNotification: () => void;
};

export const NotificationContext = createContext<NotificationContextType>({
  callNotification: () => {},
});

export const useNotification = () => useContext(NotificationContext);
